import extend from 'extend'

export default (obj1, obj2) => extend(true, {}, obj2, obj1)
